module.exports = __webpack_public_path__ + "37f74ce2c2f985d72048df892d30e3a2.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-light.eot
// module id = 28
// module chunks = 0